/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useGlobal } from '@/store'
import KImage from '@/types/KImage'
import { isDateInTheFuture } from '@/utils/date'
import Offer from './Offer'
const HOST_VARIABLE = '$SITE_URL'

class OffersSection {
  private sectionJson: any
  private offersJson: any
  public readonly uid: string;
  public readonly title: string;
  public readonly description: string;
  public readonly offers: Array<Offer>;
  public readonly seeMoreText: string;
  public readonly seeMoreUrl: string;
  public readonly icon: KImage;

  constructor (sectionJson: any, offersJson: any) {
    const global = useGlobal()
    this.sectionJson = sectionJson
    this.offersJson = offersJson
    this.uid = sectionJson.uid
    this.title = sectionJson.heading
    this.description = sectionJson.description
    this.seeMoreText = sectionJson.see_more
  
    const hostUrl = `${window.location.origin.replace('kbyg', 'member')}/${global.clientId}/${global.locale}`
    this.seeMoreUrl = sectionJson.offer_link.href.replace(HOST_VARIABLE, hostUrl)
    this.icon = new KImage(
      sectionJson.special_offer_icon.url,
      sectionJson.special_offer_icon.content_type,
      sectionJson.alt_text
    )

    this.offers = offersJson.offers
      .filter(this.isOfferAvailable)
      .sort((a: any, b: any) => a.sort_order - b.sort_order)
      .slice(0, 2)
      .map((offer: any) => Offer.of(offer, sectionJson.offer_link.title, this.seeMoreUrl, sectionJson.expiration_date_label))
  }

  static of (sectionJson: any, offersJson: any): OffersSection {
    return new OffersSection(sectionJson, offersJson)
  }

  private isOfferAvailable (offer: any) {
    const endDate = new Date(offer.end_date)
    return isDateInTheFuture(endDate)
  }
}

export default OffersSection
